import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Template from "@/services/template/template";
import type { EditTemplate } from "@/dtos/Template.dto";

export function useMarkTemplatePositive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { id: string; operation?: string }) => {
      const response = await Template.positiveReply({
        name: "",
        subject: "",
        content: "",
        lastUsedAt: new Date(),
        templateFolderId: "",
        organizationId: "",
        ...payload,
      } as EditTemplate & { operation?: string });

      if (!response.data.status) {
        throw new Error(response.data.msg || "Failed to mark template as positive");
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}

export function useMarkTemplateNegative() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { id: string; operation?: string }) => {
      const response = await Template.negativeReply({
        name: "",
        subject: "",
        content: "",
        lastUsedAt: new Date(),
        templateFolderId: "",
        organizationId: "",
        ...payload,
      } as EditTemplate & { operation?: string });

      if (!response.data.status) {
        throw new Error(response.data.msg || "Failed to mark template as negative");
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}
